const sortByFieldLength = (a: string, b: string) => {
	return a.length - b.length;
};

export default sortByFieldLength;
